import { IsNullOrWhiteSpace } from '@Utils/Micro';
// ================================================================================================
export interface IconInfo {
    className: string;
    terms?: string[];
}
// ================================================================================================
export function getIconClassName(value: string) {
    if (IsNullOrWhiteSpace(value))
        return "";
    if (value.startsWith("far") ||
        value.startsWith("fas") ||
        value.startsWith("fad") ||
        value.startsWith("fal") ||
        value.startsWith("fab") ||
        value.startsWith("fa "))
        return value;

    if (value.startsWith("fa-"))
        return "fa " + value;
}
// ================================================================================================